import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=357190b6&"
import script from "./Domains.vue?vue&type=script&lang=js&"
export * from "./Domains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357190b6')) {
      api.createRecord('357190b6', component.options)
    } else {
      api.reload('357190b6', component.options)
    }
    module.hot.accept("./Domains.vue?vue&type=template&id=357190b6&", function () {
      api.rerender('357190b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/AccountSettings/Components/Modals/Domains.vue"
export default component.exports